import { cn } from "@/utils/theme";
import {
  Avatar,
  AvatarFallback,
  Button,
  Icon,
} from "@elaniintc/goes-design-system";

export const UserCard = ({
  firstName,
  email,
  lastName,
  onClearClick,
  disabled = false,
}: {
  disabled?: boolean;
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
  onClearClick: () => void;
}) => (
  <div
    className={cn(
      "flex gap-3 items-center justify-between px-3 py-2 border border-neutral-silent rounded-lg",
      disabled ? "bg-neutral-object-accent-silent" : "bg-neutral-object",
    )}
  >
    <div className="flex gap-3 items-center justify-between w-full">
      <div className="flex gap-3 items-center">
        <Avatar shape="circle">
          <AvatarFallback color={disabled ? "neutral" : "action"}>
            {firstName ? firstName.charAt(0) : "U"}
          </AvatarFallback>
        </Avatar>
        <div className={cn("text-body", disabled && "text-on-disabled")}>
          <p className="font-semibold text-size-body">
            {firstName} {lastName}
          </p>
          <p className="text-size-body-sm">{email}</p>
        </div>
      </div>
      {!disabled && (
        <Button size="sm" variant="ghost" onClick={onClearClick}>
          <Icon type="far" name="times" />
        </Button>
      )}
    </div>
  </div>
);
